<template>
    <div>
        <NavBar v-if="$route.path !== '/rule' && $route.path !== '/iframeURL'"/>
        <router-view :class="$route.path === '/iframeURL' ? '' : 'middle-container'"></router-view>
        <Footer v-if="!$route.path.includes('rule') && $route.path !== '/iframeURL'"/>

        <van-overlay
          :show="showPopup"
          :lock-scroll="true"
          class="welcome-overlay"
          @click="showPopup = false"
        >
          <div class="welcome-popup-host" @click.stop>
            <div
              class="welcome-popup-panel"
              role="dialog"
              aria-modal="true"
              :aria-label="$t('welcome_popup.dialog_label')"
            >
              <h2 class="welcome-popup-title">
                {{ $t('welcome_popup.title') }}
              </h2>

              <div class="welcome-carousel-frame">
                <b-carousel
                  id="carousel-welcome"
                  class="welcome-carousel"
                  :interval="4000"
                  controls
                  fade
                >
                  <b-carousel-slide
                    img-src="https://storage.googleapis.com/spacetech2/mdl/mdl_welcome.webp"
                  ></b-carousel-slide>
                </b-carousel>
              </div>

              <label class="welcome-checkbox-row" for="welcome-hide-today">
                <input
                  id="welcome-hide-today"
                  v-model="isHideForToday"
                  type="checkbox"
                  class="welcome-checkbox-input"
                />
                <span class="welcome-checkbox-label">{{
                  $t('welcome_popup.hide_today')
                }}</span>
              </label>

              <button
                type="button"
                class="welcome-close-btn"
                @click="closePopup()"
              >
                {{ $t('welcome_popup.close') }}
              </button>
            </div>
          </div>
        </van-overlay>

        
        <!-- <div class="social-contacts" id="social-contacts">
            <div
                style="position: relative"
                class="cart-container"
                v-if="
                    $route.path.includes('maung-fb') ||
                    $route.path.includes('body-fb')
                "
                @click="openModalVoucher()"
            >
                <div>
                    <i class="ni ni-cart mb-2"></i>
                </div>
                <span
                    class="
                        badge badge-md badge-circle badge-floating badge-danger
                        border-white
                        cart-number
                    "
                    v-if="$route.path.includes('2d')"
                    >{{ this.$store.state.twod_slip_data.length }}</span
                >
                <span
                    class="
                        badge badge-md badge-circle badge-floating badge-danger
                        border-white
                        cart-number
                    "
                    v-if="$route.path.includes('fb')"
                    >{{ this.$store.state.fb_order.fb_matches.length }}</span
                >
                <span
                    class="
                        badge badge-md badge-circle badge-floating badge-danger
                        border-white
                        cart-number
                    "
                    v-else-if="$route.path.includes('3d')"
                    >{{ this.$store.state.threed_slip_data.length }}</span
                >
            </div>
        </div> -->


        <!-- <div class="col-4">
                <div
                    class="modal fade"
                    id="version"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="modal-form"
                    @click="closeModalOutside($event)"
                >
                    <div
                        class="modal-dialog modal- modal-dialog-centered"
                        role="document"
                    >
                        <div class="modal-content">
                            <div class="modal-body my-5 mx-3 text-md text-danger text-center">
                              {{
                                  $store.state.language === "en"
                                      ? "Your current application is out of date. Please refresh OR download again to get New Updated App."
                                      : "ယခုလက်ရှိ အသုံးပြုနေသော applicationမှာ version အဟောင်း ဖြစ်နေပါသည်။ ထို့ကြောင့် version အသစ်ဖြင့်အသုံးပြုနိုင်ရန်အတွက် refresh လုပ်ပေးပါရန် (သို့) application အား ပြန်လည် download ပြုလုပ်ပေးရန် လိုအပ်ပါသည်။"
                              }}
                              <br><br> <span class="text-dark text-sm">
                              {{
                                  $store.state.language === "en"
                                      ? "Thanks from MS Admin Team."
                                      : "MS admin အဖွဲ့မှ ကျေးဇူးတင်ပါသည်။"
                              }}
                              </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
    </div>
</template>
<script>
import { Dialog } from 'vant';
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  data() {
    return {
      showPopup: false,
      isHideForToday: false,
    }
  },

  async mounted() {
    this.checkPopupStatus();
    // console.log('mounted');
    // this.fetchWebsiteData()
    // const isLoggedIn = localStorage.getItem('token');
    // // const tokenExpire = localStorage.getItem('tokenExpire');
    // // const currentTime = new Date();
    // // if(new Date(tokenExpire) < currentTime && this.$route.path !== '/auth/login' && this.$route.path !== '/'){
    // //   localStorage.removeItem('userData');
    // //   localStorage.removeItem('token');
    // //   localStorage.removeItem('tokenExpire');
    // //   this.$router.push('/auth/login')
    // // }
    // const authUser = await this.fetchUser();
    // if (!authUser && this.$route.path !== '/auth/login') {
    //   this.$router.push('/auth/login');
    // }
    // if (isLoggedIn && authUser) {
    //   this.$store.commit(
    //     'setAmount',
    //     parseInt(this.$store.state.authUser.amount, 10),
    //   );
    // }
    // if (!isLoggedIn && this.$route.path !== '/auth/login' && this.$route.path !== '/') {
    //   this.$router.push('/auth/login');
    // }
    // if ((!authUser && this.$route.path !== '/auth/login') || (isLoggedIn && this.$store.state.authUser.roles !== 'normal')) {
    //   this.$router.push('/auth/login');
    // }
  },
  computed: {
    ...mapGetters(['getFBOrder']),
  },

  methods: {
    closePopup() {
      this.showPopup = false;
      // this.$store.commit('setMusic', true);
      const today = new Date().toISOString().split('T')[0];
      if (this.isHideForToday)
        localStorage.setItem('popupDismissedDate', today);
    },
    checkPopupStatus() {
      console.log('hello');
      const today = new Date().toISOString().split('T')[0];
      const lastDismissedDate = localStorage.getItem('popupDismissedDate');
      if (lastDismissedDate !== today) {
        this.showPopup = true;
      }
    },
    ...mapMutations(['setWholeFBMatches']),
    ...mapActions(['fetchUser']),
    closeModalOutside(event) {
      if (event.target.classList.contains('modal')) {
        this.$router.go();
      }
    },
    async fetchWebsiteData() {
      try {
        const res = await axios.get('/website-infos');
        console.log('this.$store.state.androidVersion', this.$store.state.androidVersion);
        if(res.data.data[0].androidVersion !== this.$store.state.androidVersion) {
          $('#version').modal('show');
        }
      } catch (error) {
        console.log(error);
      }
    },
    openModalVoucher() {
      if (this.$store.state.fb_order.fb_matches.length === 0) {
        const dataError = this.$store.state.language === 'en'
          ? 'Please select some teams!'
          : 'အသင်းတစ်ချို့ ရွေးပေးပါ။';
        this.dialog(dataError);
      } else {
        const matches = this.getFBOrder.fb_matches;
        if (!this.$store.state.betAmount) {
          $('#amount').modal('show');
        } else {
          for (let i = 0; i < matches.length; i += 1) {
            matches[i].bet_amount = this.$store.state.betAmount;
          }
          this.setWholeFBMatches(matches);
          $('#mobile-voucher').modal('show');
        }
      }
    },

    dialog(text) {
      Dialog.alert({
        message: text,
        confirmButtonText:
                    this.$store.state.language === 'en'
                      ? 'Go Back'
                      : 'နောက်သို့ပြန်သွားမည်။',
      }).then(() => {
        // on close
      });
    },
  },
};
</script>
<style scoped>
.welcome-overlay {
  backdrop-filter: blur(6px);
}

.welcome-popup-host {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  padding-bottom: max(1rem, env(safe-area-inset-bottom, 0px));
  box-sizing: border-box;
}

.welcome-popup-panel {
  width: 100%;
  max-width: min(92vw, 560px);
  background: linear-gradient(165deg, #22262f 0%, #16191f 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  box-shadow:
    0 4px 0 rgba(70, 244, 155, 0.12),
    0 24px 48px rgba(0, 0, 0, 0.55);
  padding: 1.1rem 1.15rem 1.25rem;
  box-sizing: border-box;
}

.welcome-popup-title {
  margin: 0 0 0.85rem;
  font-size: 1.15rem;
  font-weight: 700;
  color: #e8ecf4;
  text-align: center;
  letter-spacing: 0.02em;
}

.welcome-carousel-frame {
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: #0d0f14;
}

.welcome-carousel ::v-deep .carousel-inner {
  border-radius: 10px;
}

.welcome-carousel ::v-deep .carousel-item img {
  width: 100%;
  height: auto;
  max-height: min(52vh, 380px);
  object-fit: cover;
  display: block;
}

.welcome-carousel ::v-deep .carousel-control-prev,
.welcome-carousel ::v-deep .carousel-control-next {
  width: 2.25rem;
  opacity: 0.85;
}

.welcome-checkbox-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  margin: 1rem 0 0.85rem;
  cursor: pointer;
  user-select: none;
}

.welcome-checkbox-input {
  width: 1.125rem;
  height: 1.125rem;
  margin: 0;
  flex-shrink: 0;
  accent-color: #46f49b;
  cursor: pointer;
}

.welcome-checkbox-label {
  font-size: 0.9rem;
  font-weight: 500;
  color: #cfd6f1;
  line-height: 1.35;
  margin: 0;
}

.welcome-close-btn {
  width: 100%;
  border: none;
  border-radius: 10px;
  padding: 0.6rem 1.25rem;
  font-weight: 700;
  font-size: 0.875rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #0f1f18;
  background: linear-gradient(180deg, #62f8a8 0%, #46f49b 100%);
  box-shadow: 0 4px 16px rgba(70, 244, 155, 0.35);
  cursor: pointer;
  transition:
    transform 0.12s ease,
    box-shadow 0.15s ease;
}

.welcome-close-btn:hover {
  box-shadow: 0 6px 20px rgba(70, 244, 155, 0.45);
}

.welcome-close-btn:focus {
  outline: none;
  box-shadow:
    0 0 0 2px #16191f,
    0 0 0 4px rgba(70, 244, 155, 0.5);
}

.welcome-close-btn:active {
  transform: scale(0.98);
}

@media (max-width: 576px) {
  .welcome-popup-panel {
    max-width: min(calc(100vw - 1.5rem), 30rem);
    padding: 1rem;
  }

  .welcome-popup-title {
    font-size: 1.05rem;
    margin-bottom: 0.65rem;
  }

  .welcome-carousel ::v-deep .carousel-item img {
    max-height: 44vh;
  }
}

.cart-number {
    top: -2px !important;
    left: -2px !important;
}
.cart-number {
    position: absolute;
    top: -3px;
    left: -3px;
    text-align: center;
}
.middle-container {
    min-height: 75vh;
}
@media (max-width: 768px) {
    .cart-container {
        font-size: 30px !important;
    }
    .social-contacts div {
        width: 60px !important;
        height: 60px !important;
        margin-top: 15px;
    }
    #social-contacts .badge-circle.badge-md {
        width: 1.5rem !important;
        height: 1.5rem !important;
    }
    .cart-container {
        visibility: visible;
        font-size: 16px;
    }
    .middle-container {
        min-height: 100vh;
        margin: 0px !important;
        padding-bottom: calc(3.45rem + env(safe-area-inset-bottom, 0px));
    }
}
</style>
